import { Button, Stack, Typography, type TypographyProps } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";

export const Root = styled(Stack, {
  shouldForwardProp: (prop) => prop !== "$variant",
})<{ $variant?: "default" | "line" }>(({ theme, $variant }) => ({
  flexDirection: "column",
  gap: theme.spacing(1),
  width: "100%",
  flex: $variant === "line" ? 1 : undefined,
  minWidth: 0,
}));

export const QuestionRow = styled(Stack)({
  flexDirection: "row",
  alignItems: "flex-start",
  gap: "6px",
  width: "100%",
});

export const Question = styled(Typography)<TypographyProps>(({ theme }) => ({
  flex: 1,
  minWidth: 0,
  margin: 0,
  lineHeight: 1.2,
  [theme.breakpoints.down(575)]: {
    fontSize: "14px",
  },
}));

export const AnswerButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "selected" && prop !== "$line",
})<{ selected: boolean; $line?: boolean }>(({
  theme,
  color,
  selected,
  $line,
}) => {
  const paletteColor =
    color === "success" ? theme.palette.success : theme.palette.error;

  const isDark = theme.palette.mode === "dark";

  return {
    padding: theme.spacing(0.5, 1),
    fontSize: "12px",
    minWidth: 0,

    ...($line && {
      padding: theme.spacing(0.5, 1.5),
      fontWeight: 600,
      borderRadius: 999,
      transition: theme.transitions.create(
        ["background-color", "border-color", "color"],
        { duration: theme.transitions.duration.shorter }
      ),
    }),
    backgroundColor: selected
      ? "transparent"
      : isDark
        ? alpha(paletteColor.main, 0.12)
        : theme.palette.secondary.main,
    color: selected
      ? paletteColor.main
      : isDark
        ? paletteColor.light
        : paletteColor.main,
    borderColor: selected ? paletteColor.main : "transparent",
    "&:hover": {
      backgroundColor: selected
        ? alpha(paletteColor.main, 0.04)
        : isDark
          ? alpha(paletteColor.main, 0.2)
          : alpha(paletteColor.main, 0.12),
      borderColor: selected ? paletteColor.main : "transparent",
    },
  };
});
